/** Stable identity from the actual received Telegram message, never text/time/random IDs. */
export function telegramWorkflowMessageIdentity(message: any): { userId: string; sourceMessageId: string } {
  const decimal = (value: unknown): string | undefined => {
    if (typeof value === 'number') return Number.isSafeInteger(value) && value > 0 ? String(value) : undefined
    if (typeof value !== 'string' || !/^\d{1,64}$/.test(value)) return undefined
    const normalized = value.replace(/^0+/, '')
    return normalized || undefined
  }
  const userId = decimal(message?.peerId)
  const original = message?.id ?? message?.mid
  const id = decimal(original)
  if (!userId || !id || message?.pending === true || message?.pFlags?.is_outgoing === true) {
    throw Object.assign(new Error('收到的 Telegram 消息缺少有效的平台编号，已停止本条 AI 请求'), { code: 'TELEGRAM_MESSAGE_ID_MISSING' })
  }
  return { userId, sourceMessageId: `tg:${userId}:${id}` }
}
